import { render, staticRenderFns } from "./retail.vue?vue&type=template&id=0e53ed74"
import script from "./retail.vue?vue&type=script&lang=js"
export * from "./retail.vue?vue&type=script&lang=js"
import style0 from "./retail.vue?vue&type=style&index=0&id=0e53ed74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports